import http from '@/http';
import { parse } from '@/utils';
import { PAGE_SIZE } from '@/constants';

export const getList = async (url, filterParams = {}) => {
  try {
    const { current, pageSize } = filterParams.pagination;
    delete filterParams.pagination;

    const params = {
      page: current || 1,
      pageSize: pageSize || PAGE_SIZE,
      ...filterParams,
    };

    const { status, data } = await http.get(url, {
      params: parse.snakelize(params),
    });

    if (status === 200) {
      return {
        success: true,
        data: parse.camelize(data.results),
        totalCount: data.count,
      };
    }
    return {
      success: false,
      data: [],
    };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      data: [],
    };
  }
};
